export const FEATURE_NAMESPACE = 'feature.production-planning'
